import React from 'react';

interface Icon3DWebDevProps {
  size?: string;
}

const Icon3DWebDev: React.FC<Icon3DWebDevProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'code-pulse 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{ filter: 'drop-shadow(0 2px 8px rgba(16, 185, 129, 0.3))' }}
        >
          <defs>
            <linearGradient id="webdevGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#10b981" />
              <stop offset="50%" stopColor="#34d399" />
              <stop offset="100%" stopColor="#059669" />
            </linearGradient>
          </defs>
          <rect x="2" y="3" width="20" height="18" rx="2" fill="url(#webdevGradient)" opacity="0.15" stroke="url(#webdevGradient)" strokeWidth="1.5" />
          <path d="M7 9l-2 2 2 2" stroke="url(#webdevGradient)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
          <path d="M17 9l2 2-2 2" stroke="url(#webdevGradient)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
          <line x1="11" y1="7" x2="13" y2="15" stroke="url(#webdevGradient)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <style>{`
          @keyframes code-pulse {
            0%, 100% { transform: scale(1) rotateX(0deg); }
            50% { transform: scale(1.08) rotateX(8deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DWebDev;
